/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// Tailbase

// Helpers
function debounce(func, waitFor = 500) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    var later = function () {
      timeout = null;
      func.apply(context, args)
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, waitFor);
  };
}

// Product Detail Page
if (window.theme.pageType === 'product') {

  function hideElement(element, display = "block") {
    var elDisplay = window.getComputedStyle(element).display;
    if (elDisplay === display) {
      element.style.display = "none";
    }
  }
  // Toggle Functions
  function toggleElement(element, display = "block") {
    var elDisplay = window.getComputedStyle(element).display;
    if (elDisplay === "none") {
      element.style.display = display;
    } else {
      element.style.display = "none";
    }
  }

  function toggleElementText(element, hideText, showText) {
    if (hideText && showText) {
      if (element.innerHTML === hideText) {
        element.innerHTML = showText;
      } else {
        element.innerHTML = hideText;
      }
    }
  }


  // Product Detail Page
  // View more Button
  document.querySelectorAll('[data-product-description]').forEach(function (description) {
    var completeText = description.querySelector('.product-meta__complete-text');
    var viewMoreBtn = description.querySelector('[data-description-toggle]');
    var wordsLimit = parseInt(description.dataset.wordLimit, 10);

    if (!completeText || !viewMoreBtn || !(wordsLimit > 0)) return;

    if (!completeText.querySelector('p, ul, ol, li, br, div')) {
      completeText.classList.add('product-meta__plain-description');
    }

    var truncatedText = completeText.cloneNode(true);
    truncatedText.removeAttribute('id');
    truncatedText.classList.replace('product-meta__complete-text', 'product-meta__truncated-description');
    truncatedText.querySelectorAll('[id]').forEach(function (element) {
      element.removeAttribute('id');
    });

    var walker = document.createTreeWalker(truncatedText, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    var totalWords = 0;
    while (walker.nextNode()) {
      var words = Array.from(walker.currentNode.textContent.matchAll(/\S+/g));
      if (words.length) {
        textNodes.push({ node: walker.currentNode, words: words });
        totalWords += words.length;
      }
    }

    if (totalWords <= wordsLimit) return;

    var remainingWords = wordsLimit;
    for (var entry of textNodes) {
      if (entry.words.length >= remainingWords) {
        var lastWord = entry.words[remainingWords - 1];
        var range = document.createRange();
        range.selectNodeContents(truncatedText);
        range.setStart(entry.node, lastWord.index + lastWord[0].length);
        range.deleteContents();
        entry.node.textContent += '...';
        break;
      }
      remainingWords -= entry.words.length;
    }

    description.insertBefore(truncatedText, completeText);
    completeText.hidden = true;
    viewMoreBtn.hidden = false;
    viewMoreBtn.addEventListener('click', function () {
      var expanded = viewMoreBtn.getAttribute('aria-expanded') !== 'true';
      completeText.hidden = !expanded;
      truncatedText.hidden = expanded;
      viewMoreBtn.setAttribute('aria-expanded', String(expanded));
      viewMoreBtn.textContent = expanded ? window.languages.viewLess : window.languages.viewMore;

      var productInfoElement = description.closest('.product-block-list__item--info .card');
      var productWrapper = description.closest('.product-block-list__wrapper');
      if (productInfoElement && productWrapper) {
        productWrapper.style.minHeight = productInfoElement.clientHeight + 'px';
      }
    });
  });


  // Rebate Lean More Toggle
  // Add onresize debounce function
  var rebateLearnMore = document.getElementsByClassName('product-form__rebate-learn');
  var rebateInfo = document.getElementsByClassName('product-form__rebate-info');
  var rebates = document.getElementsByClassName('product-form__rebates');
  var warehouseBody = document.getElementsByClassName('warehouse--v1');

  function handleDesktopLearnMoreClick(e) {
    toggleElement(rebateInfo[0]);
    e.stopPropagation();
  }

  function handleMobileLearnMoreClick() {
    scrollToWithOffSet(rebates[0], 100)
  }

  function handleRebateInfoClick(e) {
    e.stopPropagation();
  }

  function handleBodyClick() {
    hideElement(rebateInfo[0]);
  }

  function rebateBehavior() {
    if (rebateLearnMore.length > 0 && rebateInfo.length > 0 && warehouseBody.length > 0 && rebates.length > 0) {
      var isDesktop = window.matchMedia('screen and (min-width: 1000px)').matches;
      var isMobile = window.matchMedia('screen and (max-width: 999px)').matches;

      if (isDesktop) {
        rebateLearnMore[0].removeEventListener('click', handleMobileLearnMoreClick);
        warehouseBody[0].addEventListener('click', handleBodyClick)
        rebateLearnMore[0].addEventListener('click', handleDesktopLearnMoreClick);
        rebateInfo[0].addEventListener('click', handleRebateInfoClick);
        rebateLearnMore[0].addEventListener('keyup', function(event) {
          if (event.keyCode === 13) {
            handleDesktopLearnMoreClick()
          }
        });

      }
      if (isMobile) {
        rebateLearnMore[0].removeEventListener('click', handleDesktopLearnMoreClick);
        rebateInfo[0].removeEventListener('click', handleRebateInfoClick);
        rebateLearnMore[0].addEventListener('click', handleMobileLearnMoreClick);
        rebateLearnMore[0].addEventListener('keyup', function(event) {
          if (event.keyCode === 13) {
            handleMobileLearnMoreClick()
          }
        });
      }
    }
  }

  var debouncedRebateBehavior = debounce(rebateBehavior)

  window.addEventListener('resize', debouncedRebateBehavior)
  window.addEventListener('load', rebateBehavior)

  // Tabs
  var productTabsSection = document.getElementById("product-tabs-section");
  if (productTabsSection) {
    var productTabsoptions = JSON.parse(productTabsSection.getAttribute('data-section-settings'));
  
    var productTabsMenu = document.getElementsByClassName('product_tabs__titles');
    var header = document.getElementById("shopify-section-header");
  
    if (productTabsMenu.length > 0 && header) {
      // The section renders one tabs block per variant and hides the others,
      // so always use the visible menu (a hidden one has a top position of 0).
      function getVisibleProductTabsMenu() {
        for (var i = 0; i < productTabsMenu.length; i++) {
          if (productTabsMenu[i].offsetParent !== null) return productTabsMenu[i];
        }
        return null;
      }

      // Offset is measured once per menu, before it becomes sticky
      var productTabsMenuOffsets = new Map();
      function getProductTabsMenuOffsetTop(menu) {
        if (!productTabsMenuOffsets.has(menu)) {
          productTabsMenuOffsets.set(menu, getTopPosition(menu));
        }
        return productTabsMenuOffsets.get(menu);
      }

      window.addEventListener('scroll', function (e) {
        if (this.window.innerWidth > 999) {
          var visibleProductTabsMenu = getVisibleProductTabsMenu();
          if (!visibleProductTabsMenu) return;

          if (window.pageYOffset > (getProductTabsMenuOffsetTop(visibleProductTabsMenu) - 200)) {
            header.classList.add("hide-header-desktop")
            visibleProductTabsMenu.classList.add("tabs-titles-sticky")
            if (rebateInfo.length > 0) {
              rebateInfo[0].style.display = 'none'
            }
          } else if (header.style.opacity == 0) {
            header.classList.remove("hide-header-desktop")
            for (var i = 0; i < productTabsMenu.length; i++) {
              productTabsMenu[i].classList.remove("tabs-titles-sticky")
            }
          }
        }
      });
    }
  
    var featuresLink = document.getElementById("features-title");
    var featuresContent = document.getElementById("product-features");
  
    var specsLink = document.getElementById("specs-title");
    var specsContent = document.getElementById("product-specs");
  
    var documentsLink = document.getElementById("documents-title");
    var documentsContent = document.getElementById("product-documents");
  
    var associatedProductsLink = document.getElementById("associated-products-title");
    var associatedProductsContent = document.getElementById("product-associated-products");
  
    var backToProductInfoMenuBtn = document.getElementsByClassName("product_tabs__menu-btn");
    var productInfoMenu = document.getElementById("product-info-menu");

  
    if (featuresLink && featuresContent) scrollToWithOffSetListener(featuresLink, featuresContent, productTabsoptions.defaultOffset);
    if (specsLink && specsContent) scrollToWithOffSetListener(specsLink, specsContent, productTabsoptions.defaultOffset);
    if (documentsLink && documentsContent) scrollToWithOffSetListener(documentsLink, documentsContent, productTabsoptions.defaultOffset);
    if (associatedProductsLink && associatedProductsContent) scrollToWithOffSetListener(associatedProductsLink, associatedProductsContent, productTabsoptions.defaultOffset);
  
    if (backToProductInfoMenuBtn.length > 0 && productInfoMenu) {
      for (var i = 0; i < backToProductInfoMenuBtn.length; i++) {
        scrollToWithOffSetListener(backToProductInfoMenuBtn.item(i), productInfoMenu, productTabsoptions.defaultOffset)
      }
    }
  }
 

  function scrollToWithOffSetListener(link, content, offset) {
    link.addEventListener('click', function () {
      scrollToWithOffSet(content, offset);
    });
    link.addEventListener('keyup', function (event) {
      if (event.keyCode === 13) {
        scrollToWithOffSet(content, offset);
      }
    });
  }

  function scrollToWithOffSet(content, offset) {
    window.scrollTo({
      top: getTopPosition(content) - offset,
      behavior: 'smooth'
    });
  }

  function getTopPosition(content) {
    var rect = content.getBoundingClientRect()
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  }

  // Add To cart
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const newAction = productForm.action.replace("/add", "");

if (productForm) {
    const validateInstallationProducts = document.getElementsByClassName('installation product-form__validate-products');
    const validateWarrantyProducts     = document.getElementsByClassName('warranty product-form__validate-products');
    const isInstallationValidating     = validateInstallationProducts.length > 0;
    const isWarrantyValidating         = validateWarrantyProducts.length > 0;

    // ── Helpers ────────────────────────────────────────────────────────────

    function displayValidationMessage(elements) {
      Array.from(elements).forEach(el => el.style.display = 'block');
    }

    function hideValidationMessage(elements) {
      Array.from(elements).forEach(el => el.style.display = 'none');
    }

    function handleNoneForCheckbox(input, elements) {
      if (input.hasAttribute('none') && input.classList.contains('checkbox')) {
        removeAllButNone(elements);
      } else if (input.classList.contains('checkbox')) {
        removeNone(elements);
      }
    }

    function removeNone(parentEl) {
      Array.from(parentEl).forEach(input => { if (input.hasAttribute('none')) input.checked = false; });
    }

    function removeAllButNone(parentEl) {
      Array.from(parentEl).forEach(input => { if (!input.hasAttribute('none')) input.checked = false; });
    }

    // ── Validation ─────────────────────────────────────────────────────────
    // Called by theme.js _addToCart before submitting. Returns false if any
    // required selection is missing, and shows the relevant message(s).

    window.validateAddToCartProducts = function() {
      let isValid = true;

      if (isInstallationValidating) {
        const inputs = document.getElementsByClassName('installation add-to-cart-product__checkbox');
        // inputs.length === 0 means current variant has no installations — skip
        if (inputs.length > 0 && !Array.from(inputs).some(i => i.checked)) {
          displayValidationMessage(validateInstallationProducts);
          isValid = false;
        }
      }

      if (isWarrantyValidating) {
        const liveDropdown   = document.getElementById('add-to-cart-products__dropdown');
        const warrantyInputs = document.getElementsByClassName('warranty add-to-cart-product__checkbox');

        if (liveDropdown !== null) {
          // Dropdown format: selectedIndex 0 = disabled placeholder (nothing chosen)
          const selected = liveDropdown.selectedIndex > 0;
          if (!selected) {
            displayValidationMessage(validateWarrantyProducts);
            isValid = false;
          }
        } else if (warrantyInputs.length > 0) {
          // List format: at least one radio must be checked (including None)
          if (!Array.from(warrantyInputs).some(i => i.checked)) {
            displayValidationMessage(validateWarrantyProducts);
            isValid = false;
          }
        }
        // warrantyInputs.length === 0 and no dropdown = variant has no warranties — skip
      }

      return isValid;
    };

    // ── Clear messages on variant switch ───────────────────────────────────
    // Called by theme.js _onVariantChanged before re-rendering sections.

    window.clearValidationMessages = function() {
      hideValidationMessage(validateInstallationProducts);
      hideValidationMessage(validateWarrantyProducts);
    };

    // ── Re-wire installation & warranties listeners after re-render ─────────────────────
    // Called by theme.js after _updateInstallationsVariantMetafields replaces
    // the DOM. Attaches change listeners to the newly created input nodes.

    window.rewireInstallationListeners = function() {
      if (!isInstallationValidating) return;
      const inputs = document.getElementsByClassName('installation add-to-cart-product__checkbox');
      Array.from(inputs).forEach(input => {
        input.addEventListener('change', () => {
          handleNoneForCheckbox(input, inputs);
          hideValidationMessage(validateInstallationProducts);
        });
      });
    };

    if (isInstallationValidating) {
      window.rewireInstallationListeners();
    }

    window.rewireWarrantyListeners = function() {
      if (!isWarrantyValidating) return;

      // List format
      const warrantyInputs = document.getElementsByClassName('warranty add-to-cart-product__checkbox');
      Array.from(warrantyInputs).forEach(input => {
        input.addEventListener('change', () => {
          handleNoneForCheckbox(input, warrantyInputs);
          hideValidationMessage(validateWarrantyProducts);
        });
      });

      // Dropdown format
      const liveDropdown = document.getElementById('add-to-cart-products__dropdown');
      if (liveDropdown !== null) {
        liveDropdown.addEventListener('change', () => {
          hideValidationMessage(validateWarrantyProducts);
        });
      }
    };

    if (isWarrantyValidating) {
      window.rewireWarrantyListeners();
    }

    // ── Cart submission ────────────────────────────────────────────────────
    // theme.js handles the actual cart submit via _addToCart (click handler).
    // This submit listener is a fallback for any other submit path.

    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (typeof window.validateAddToCartProducts === 'function') {
        if (!window.validateAddToCartProducts()) return;
      }

      var checkboxes       = document.getElementsByClassName('add-to-cart-product__checkbox');
      var addToCartProducts = [];

      for (var checkbox of checkboxes) {
        if (checkbox.checked && checkbox.getAttribute('data-variant')) {
          addToCartProducts.push({ id: checkbox.getAttribute('data-variant'), quantity: '1' });
        }
      }

      const liveDropdown = document.getElementById('add-to-cart-products__dropdown');
      if (liveDropdown !== null) {
        const selectedOption = liveDropdown.options[liveDropdown.selectedIndex];
        const dataVariant    = selectedOption?.getAttribute('data-variant');
        if (dataVariant) addToCartProducts.push({ id: dataVariant, quantity: '1' });
      }

      let formData = new FormData(productForm);
      var products = [
        // Related products (warranties / installations) carry a reference to the
        // main product so the cart can cascade-remove them together.
        ...addToCartProducts.map(product => ({
          id: product.id,
          quantity: product.quantity,
          properties: {
            "_related_product_for": formData.get("id"),
            "_is_related": true
          }
        })),
        // Main product
        { id: formData.get('id'), quantity: formData.get('quantity') }
      ];

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items: products }),
      })
        .then(() => { location.href = newAction; })
        .catch(error => { console.error('Error:', error); });
    });
  }

  // Syndigo
  const p = document.querySelector('syndigo-powerpage')
  if (p) {
    p.addEventListener('content', function (ev) {
      if (!ev.detail.hasContent) {
        p.remove();
      }
    })
  }

  // loadbee
  window.onload = () => {
    // displaying the loadbee Manufacturer Info if there is some content
    var loadbeeContainer = document.querySelector('#product-manufacturer-loadbee');
    if (loadbeeContainer) {
      setTimeout(() => {
        if (loadbeeContainer.querySelector('.loadbeeTabContent').children.length > 0)
          loadbeeContainer.style.display = 'block';
      }, 1000);
    }
  };

}

//Warranties & Installations
  // ─── Shared helpers ────────────────────────────────────────────────────────

function _getMetafieldSettings(className) {
  const get = (id) => document.querySelector(`.product-form__add-to-cart-products-data.${className} #${id}`)?.value ?? null;
  return {
    sortBy:            get('sort_by_price'),
    multipleSelect:    get('multiple_select'),
    validateAddToCart: get('validate_add_to_cart'),
    hadProductLink:    get('has_product_link'),
    settingsTitle:     get('settings_title'),
    inputType:         get('inputType'),
    className:         get('className'),
    generalNone:       get('generalNone'),
    displayFormat:     get('displayFormat'),
    generalSelect:     get('generalSelect'),
  };
}

function _sortProducts(products, sortBy) {
  return [...products].sort((a, b) =>
    sortBy === 'asc' ? a.price - b.price : b.price - a.price
  );
}

function _buildListItemHtml(product, settings) {
  const { inputType, settingsTitle, className, hadProductLink } = settings;
  const { addToCartProdVariantId, featured_image, title, handle, price, url } = product;

  const hasImage  = Boolean(featured_image);
  const imgSrc    = hasImage ? featured_image.replace('.webp', '_130x.webp') : null;
  const linkStart = hadProductLink ? `<a href="/products/${handle}">` : '';
  const linkEnd   = hadProductLink ? `</a>` : '';
  const imgHtml   = hasImage
    ? `${hadProductLink ? `<a href="${url}">` : ''}<img class="add-to-cart-product__image" src="${imgSrc}" alt="${title}">${hadProductLink ? '</a>' : ''}`
    : '';

  return `
    <div class="card add-to-cart-products__card">
      <div class="${hasImage ? 'card__section add-to-cart-product__content' : 'card__section add-to-cart-product__content add-to-cart-product__content--no-image'}">
        <input
          class="${inputType} add-to-cart-product__checkbox ${className}"
          type="${inputType}"
          name="${settingsTitle}"
          data-variant="${addToCartProdVariantId}" />
        ${imgHtml}
        ${linkStart}<span class="add-to-cart-product__title">${title}</span>${linkEnd}
        <span class="add-to-cart-product__price">$${(price / 100).toFixed(2)}</span>
      </div>
    </div>`;
}

function _renderListFormat(parentEl, products, settings) {
  const { inputType, settingsTitle, className, generalNone, multipleSelect, validateAddToCart, sortBy } = settings;

  // Mirror the Liquid condition: show none when single-select (multipleSelect is false) OR validation is on.
  // Values from _getMetafieldSettings are strings ("true"/"false"), so compare explicitly.
  const noneOptionHtml = (multipleSelect !== 'true' || validateAddToCart === 'true')
    ? `<div class="card add-to-cart-products__card">
          <div class="card__section add-to-cart-product__content add-to-cart-product__content--no-image">
            <input class="${inputType} add-to-cart-product__checkbox ${className}" name="${settingsTitle}" type="${inputType}" none/>
            <span class="add-to-cart-product__title">${generalNone}</span>
          </div>
        </div>`
    : '';

  const itemsHtml = _sortProducts(products, sortBy)
    .map(p => _buildListItemHtml(p, settings))
    .join('');

  parentEl.innerHTML = noneOptionHtml + itemsHtml;
}

function _renderDropdownFormat(parentEl, products, settings) {
  const { settingsTitle, className, generalNone, generalSelect, sortBy } = settings;

  const optionsHtml = _sortProducts(products, sortBy).map(({ addToCartProdVariantId, title, price }) => `
    <div class="card add-to-cart-products__card">
      <option class="dropdown add-to-cart-product__dropdown ${className}"
        data-variant="${addToCartProdVariantId}"
        value="${addToCartProdVariantId}"
        title="$${(price / 100).toFixed(2)}">
        ${title} - $${(price / 100).toFixed(2)}
      </option>
      <span class="add-to-cart-product__price">$${(price / 100).toFixed(2)}</span>
    </div>`).join('');

  parentEl.innerHTML = `
    <div class="form__input-wrapper form__input-wrapper--labelled">
      <div id="dropdown-form-warranties" class="select-wrapper select-wrapper--primary">
        <span class="dropdown-toggle"></span>
        <select id="add-to-cart-products__dropdown" name="${settingsTitle}" title="${generalSelect}">
          <option value="" disabled selected data-variant></option>
          <option class="dropdown add-to-cart-product__dropdown ${className}" value="${generalNone}" data-variant>
            ${generalNone}
          </option>
          ${optionsHtml}
        </select>
      </div>
      <label for="dropdown-form-warranties" class="form__floating-label">${generalSelect}</label>
    </div>`;

  setSvgDownArrow();
}

function _renderAddToCartSection(element, products, sectionClass, settings) {
  const wiSection      = element.querySelector(`.product-form__add-to-cart-products.${sectionClass}`);
  const wiSectionTitle = element.querySelector(`.text--strong.${sectionClass}`);
  const parentEl       = element.getElementsByClassName(`product-form__add-to-cart-products ${sectionClass}`)[0];

  if (!products?.length) {
    wiSection?.style.setProperty('display', 'none');
    wiSectionTitle?.style.setProperty('display', 'none');
    if (parentEl) parentEl.innerHTML = '';
    return;
  }

  wiSection?.style.setProperty('display', 'grid');
  wiSectionTitle?.style.setProperty('display', 'block');

  if (settings.displayFormat === 'list')     _renderListFormat(parentEl, products, settings);
  if (settings.displayFormat === 'dropdown') _renderDropdownFormat(parentEl, products, settings);
}

// Dropdown Arrow (replace render icon)
function setSvgDownArrow(){
  const toggle = document.querySelector('.dropdown-toggle');

  // Create the SVG icon element
  const svgIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svgIcon.setAttribute("width", "12");
  svgIcon.setAttribute("height", "12");
  svgIcon.setAttribute("viewBox", "0 0 12 8");
  svgIcon.setAttribute("class", "dropdown-arrow");

  // Create the arrow path
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("d", "M10 2L6 6 2 2"); // Simple V-shape
  path.setAttribute("stroke", "currentColor");
  path.setAttribute("fill", "none");

  svgIcon.appendChild(path);
  toggle.appendChild(svgIcon);
}

// MINI-CART CASCADE REMOVAL: Remove related products when main product is removed
(function() {
  function removeMainProductAndRelatedInMiniCart(mainVariantId, clickedButton) {
    const miniCartItems = document.querySelectorAll('.mini-cart__line-item');
    const linesToRemove = [];

    // Find main product line number
    miniCartItems.forEach((item, index) => {
      const removeButton = item.querySelector('.main-product-remove');
      if (removeButton && removeButton.getAttribute('data-main-variant-id') === mainVariantId) {
        const lineNumber = removeButton.getAttribute('data-line');
        if (lineNumber) {
          linesToRemove.push(parseInt(lineNumber, 10));
        }
      }
    });

    // Find all related products for this main product
    miniCartItems.forEach((item, index) => {
      const relatedToAttr = item.getAttribute('data-related-to');
      const relatedDiv = item.querySelector('[data-related-to="' + mainVariantId + '"]');

      if (relatedDiv || relatedToAttr === mainVariantId) {
        const removeButton = item.querySelector('.related-product-remove');
        if (removeButton) {
          const lineNumber = removeButton.getAttribute('data-line');
          if (lineNumber) {
            linesToRemove.push(parseInt(lineNumber, 10));
          }
        }
      }
    });

    if (linesToRemove.length === 0) {
      return false;
    }

    // Sort lines in descending order to avoid renumbering issues
    linesToRemove.sort((a, b) => b - a);
    removeLinesSequentially(linesToRemove, 0);
    return true;
  }

  function removeLinesSequentially(linesToRemove, index) {
    if (index >= linesToRemove.length) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.theme && window.theme.cart && window.theme.cart.refresh) {
        window.theme.cart.refresh();
      }
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    const lineToRemove = linesToRemove[index];

    fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: lineToRemove,
        quantity: 0
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status} for line ${lineToRemove}`);
      }
      return response.json();
    })
    .then(cart => {
      setTimeout(() => {
        removeLinesSequentially(linesToRemove, index + 1);
      }, 100);
    })
    .catch(error => {
      setTimeout(() => {
        removeLinesSequentially(linesToRemove, index + 1);
      }, 100);
    });
  }

  function initializeMiniCartCascadeListeners() {
    document.addEventListener('click', function(event) {
      const clickedButton = event.target.closest('.main-product-remove');
      if (clickedButton) {
        const mainVariantId = clickedButton.getAttribute('data-main-variant-id');
        if (mainVariantId) {
          event.preventDefault();
          event.stopPropagation();
          removeMainProductAndRelatedInMiniCart(mainVariantId, clickedButton);
        }
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMiniCartCascadeListeners);
  } else {
    initializeMiniCartCascadeListeners();
  }
})();

// CART PAGE CASCADE REMOVAL: Remove related products (warranties/installations)
// when the main product is removed from the /cart page. On the cart page the
// related line items only render nested under their parent, so removing just the
// main line would orphan them — invisible in the list but still counted in the
// total and cart counter. We fetch the authoritative cart, then remove the main
// item together with every related item that references it, keyed by the stable
// line-item key (avoids line-number renumbering issues) via /cart/update.js.
(function() {
  function updateCart(updates) {
    return fetch(window.routes.cartUrl + '/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
    .then(function() { window.location.reload(); })
    .catch(function() { window.location.reload(); });
  }

  function cascadeRemoveMainProductFromCartPage(mainKey) {
    fetch(window.routes.cartUrl + '.js', { credentials: 'same-origin' })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var updates = {};
        updates[mainKey] = 0;

        var mainItem = cart.items.filter(function(item) {
          return item.key === mainKey;
        })[0];

        if (mainItem) {
          var mainVariantId = String(mainItem.variant_id);
          cart.items.forEach(function(item) {
            var props = item.properties || {};
            if (props._is_related && String(props._related_product_for) === mainVariantId) {
              updates[item.key] = 0;
            }
          });
        }

        return updateCart(updates);
      })
      .catch(function() { window.location.reload(); });
  }

  function initializeCartPageCascadeListeners() {
    document.addEventListener('click', function(event) {
      var clickedButton = event.target.closest('.cart-main-product-remove');
      if (!clickedButton) return;

      var mainKey = clickedButton.getAttribute('data-line-item-key');
      if (!mainKey) return;

      event.preventDefault();
      event.stopPropagation();
      cascadeRemoveMainProductFromCartPage(mainKey);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCartPageCascadeListeners);
  } else {
    initializeCartPageCascadeListeners();
  }
})();

// CART PAGE ORPHAN CLEANUP: safety net that removes related products
// (warranties/installations) left behind when their main product is no longer in
// the cart — e.g. the main line was decreased to 0 with the quantity stepper, or
// the cart was already in this state before the cascade fix landed. Runs once on
// load of the /cart page and reloads only when it actually removed something, so
// it cannot loop.
(function() {
  function cleanupOrphanedRelatedItems() {
    if (!window.theme || window.theme.pageType !== 'cart') return;

    fetch(window.routes.cartUrl + '.js', { credentials: 'same-origin' })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        // Variant ids of every main (non-related) item currently in the cart.
        var mainVariantIds = {};
        cart.items.forEach(function(item) {
          var props = item.properties || {};
          if (!props._is_related) {
            mainVariantIds[String(item.variant_id)] = true;
          }
        });

        // Any related item whose parent is gone is orphaned.
        var updates = {};
        var hasOrphans = false;
        cart.items.forEach(function(item) {
          var props = item.properties || {};
          if (props._is_related && !mainVariantIds[String(props._related_product_for)]) {
            updates[item.key] = 0;
            hasOrphans = true;
          }
        });

        if (!hasOrphans) return;

        fetch(window.routes.cartUrl + '/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        })
        .then(function() { window.location.reload(); });
      })
      .catch(function() { /* leave the cart unchanged on error */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupOrphanedRelatedItems);
  } else {
    cleanupOrphanedRelatedItems();
  }
})();

//StoreOnly ItemFlag ────────────────────────────────────────────────────────

// Handle StoreOnly ItemFlag visibility on variant change
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var paymentContainer = document.querySelector('.product-form__payment-container');

  // Handle Add to Cart button visibility
  if (paymentContainer && variant) {
    var isStoreOnly = false;
    var variantsStoreOnlyData = paymentContainer.getAttribute('data-variants-store-only');
    if (variantsStoreOnlyData) {
      try {
        var variantsStoreOnly = JSON.parse(variantsStoreOnlyData);
        var variantData = variantsStoreOnly[variant.id];

        if (variantData && variantData.storeOnly === true) {
          isStoreOnly = true;
        }
      } catch (e) {
        console.error('Error parsing variants StoreOnly data:', e);
      }
    }

    // WI 115984: hide the buy button for StoreOnly variants OR variants with no price ($0)
    var noPrice = !variant.price || variant.price <= 0;
    if (isStoreOnly || noPrice) {
      paymentContainer.classList.add('hide-element');
    } else {
      paymentContainer.classList.remove('hide-element');
    }
  }
  
  // Handle ItemFlags labels update on variant change
  if (variant) {
    var labelList = document.querySelector('.product-meta__label-list');
    var labelsContainer = document.querySelector('.product-meta__itemflags-labels-container');
    var inventoryLabelContainer = document.querySelector('.product-meta__inventory-label-container');
    
    if (labelList && inventoryLabelContainer) {
      var variantsInventoryLabelsData = labelList.getAttribute('data-variants-inventory-labels');
      if (variantsInventoryLabelsData) {
        try {
          var variantsInventoryLabels = JSON.parse(variantsInventoryLabelsData);
          var inventoryStatus = variantsInventoryLabels[variant.id];
          var locale = document.documentElement.lang || 'en';
          var localeMatch = document.body.className.match(/locale-(\w+)/);
          if (localeMatch) {
            locale = localeMatch[1];
          }

          inventoryLabelContainer.innerHTML = '';

          if (inventoryStatus === 'in_stock' || inventoryStatus === 'sold_out') {
            var inventoryLabel = document.createElement('span');
            inventoryLabel.className = inventoryStatus === 'in_stock'
              ? 'product-label product-label--custom1'
              : 'product-label product-label--out-of-stock';

            if (inventoryStatus === 'in_stock') {
              inventoryLabel.textContent = locale === 'fr'
                ? labelList.getAttribute('data-inventory-label-in-stock-fr')
                : labelList.getAttribute('data-inventory-label-in-stock-en');
            } else {
              inventoryLabel.textContent = locale === 'fr'
                ? labelList.getAttribute('data-inventory-label-sold-out-fr')
                : labelList.getAttribute('data-inventory-label-sold-out-en');
            }

            inventoryLabelContainer.appendChild(inventoryLabel);
          }
        } catch (e) {
          console.error('Error parsing variants inventory label data:', e);
          console.error('Data was:', variantsInventoryLabelsData);
        }
      }
    }

    if (labelList && labelsContainer) {
      var variantsFlagsData = labelList.getAttribute('data-variants-itemflags');
      if (variantsFlagsData) {
        try {
          var variantsFlags = JSON.parse(variantsFlagsData);
          var variantFlags = variantsFlags[variant.id];

          if (variantFlags && variantFlags.hasFlags === true && variantFlags.flags && variantFlags.flags.length > 0) {
            // Get current locale from request or html lang
            var locale = document.documentElement.lang || 'en';
            // Also check for request.locale.iso_code pattern in the page
            var localeMatch = document.body.className.match(/locale-(\w+)/);
            if (localeMatch) {
              locale = localeMatch[1];
            }

            labelsContainer.innerHTML = '';

            // Build and append each label
            variantFlags.flags.forEach(function(flag) {
              var labelText = locale === 'fr' ? flag.label_fr : flag.label_en;
              if (labelText) {
                var span = document.createElement('span');
                span.className = 'product-label product-label--custom1';
                span.textContent = labelText;
                labelsContainer.appendChild(span);
              }
            });
          } else {
            // No flags for this variant
            labelsContainer.innerHTML = '';
          }
        } catch (e) {
          console.error('Error parsing variants ItemFlags data:', e);
          console.error('Data was:', variantsFlagsData);
        }
      }
    }
  }

  // Handle QuantitiesInFeeds update on variant change
  if (variant) {
    var quantitiesWrapper = document.querySelector('[data-quantities-in-feeds-wrapper]');

    if (quantitiesWrapper) {
      var variantsQuantitiesData = quantitiesWrapper.getAttribute('data-variants-quantities-in-feeds');
      var perPackageLabel = quantitiesWrapper.getAttribute('data-per-package') || '';
      var language = quantitiesWrapper.getAttribute('data-language') || (document.documentElement.lang || 'en');
      var quantitiesText = quantitiesWrapper.querySelector('[data-quantities-in-feeds-text]');

      if (variantsQuantitiesData && quantitiesText) {
        try {
          var variantsQuantities = JSON.parse(variantsQuantitiesData);
          var quantityValue = variantsQuantities[variant.id];

          if (quantityValue) {
            quantitiesWrapper.style.display = '';

            if (language === 'fr') {
              quantitiesText.textContent = perPackageLabel + ' ' + quantityValue;
            } else {
              quantitiesText.textContent = quantityValue + ' ' + perPackageLabel;
            }
          } else {
            quantitiesWrapper.style.display = 'none';
          }
        } catch (e) {
          console.error('Error parsing variants QuantitiesInFeeds data:', e);
        }
      }
    }
  }
});
(function() {
  var selector = 'shopify-payment-terms';
  var styleAttribute = 'data-tailbasify-installments-styles';
  var css = '#shopify-installments{display:block!important;width:100%!important;min-width:100%!important}' +
    '#shopify-installments p{display:block!important;width:100%!important;min-width:max-content!important;text-align:left!important;margin:0!important;overflow:visible!important}' +
    '#shopify-installments-content{display:inline!important;white-space:nowrap!important}';

  function applyInstallmentsStyles(host) {
    var shadowRoot = host.shadowRoot;

    if (!shadowRoot) {
      if (window.customElements && window.customElements.whenDefined) {
        window.customElements.whenDefined(selector).then(function() {
          applyInstallmentsStyles(host);
        });
      }
      return;
    }

    if (shadowRoot.querySelector('style[' + styleAttribute + ']')) return;

    var style = document.createElement('style');
    style.setAttribute(styleAttribute, '');
    style.textContent = css;
    shadowRoot.appendChild(style);
  }

  function scan(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;

    if (node.nodeType === 1 && node.matches(selector)) {
      applyInstallmentsStyles(node);
    }

    var hosts = node.querySelectorAll(selector);
    for (var index = 0; index < hosts.length; index++) {
      applyInstallmentsStyles(hosts[index]);
    }
  }

  scan(document);

  new MutationObserver(function(mutations) {
    for (var mutationIndex = 0; mutationIndex < mutations.length; mutationIndex++) {
      var addedNodes = mutations[mutationIndex].addedNodes;
      for (var nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex++) {
        scan(addedNodes[nodeIndex]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

